import { api } from 'config'

export const ROLE_URL = {
   getRoles: `${api.public}v1/role`,
   patchRole: `${api.public}v1/role`
}
